import(/* webpackMode: "eager" */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/app/(alfamall)/loading.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/app/(alfamall)/pages/Homepage.jsx");
